import { createSlice } from '@reduxjs/toolkit';
import {
  GET_STATS
} from '../constants/constants';

const initialState = {
  total_users: 0,
  paid_users: 0,
  free_users: 0,
  checklists: 0,
  topics: 0,
  chapters: 0,
  parts: 0
};

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(GET_STATS, (state, action) => ({ ...state, ...action.data }));
  }
});

export default statsSlice.reducer;
